import script from "./DetalleTorneoLiveMasView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetalleTorneoLiveMasView.vue?vue&type=script&setup=true&lang=ts"

import "./DetalleTorneoLiveMasView.vue?vue&type=style&index=0&id=1d120db1&lang=css"

const __exports__ = script;

export default __exports__